<div class="card">
  <div class="card-header">
    <span class="card-title">Test Manager Reports</span>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <div class="card-body">
    <p>This will generate the manager procedure reports and send any eligible emails.</p>
  </div>

  <div class="card-footer">
    <div mat-dialog-actions align="center">
      <button mat-flat-button color="warn" (click)="cancel()" [disabled]="loading">Cancel</button>
      <button mat-flat-button color="primary" (click)="generateReports()" [disabled]="loading">Generate Reports</button>
    </div>
  </div>
</div>
